import React from "react";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Separator } from "../components/ui/separator";

import { useState } from "react";
import { useBaseOwnerId, useModelCreate, useModelIndex, useModelUpdate } from "@rhino-project/core/hooks";
import { asSubmission, listResults } from "../lib/thirdDoorAdapters";

export default function SubmissionDetail() {
    const [action, setAction] = useState("");
    const organizationId = useBaseOwnerId();
    const { resources } = useModelIndex("submission" as any, { limit: 1 } as any);
    const submission = asSubmission(listResults(resources)[0] ?? {});
    const { mutate: updateSubmission } = useModelUpdate("submission" as any);
    const { mutate: createRoutingRecommendation } = useModelCreate("routing_recommendation" as any);
    const { mutate: createCommunication } = useModelCreate("communication" as any);
    const applyAction = (label: string) => {
      if (submission.id) {
        updateSubmission({ id: submission.id, status: label, sponsor_action: label } as any);
        if (label === "Routed to mechanism") createRoutingRecommendation({ submission_id: submission.id, organization_id: Number.isFinite(organizationId) ? organizationId : undefined, recommended_mechanism: submission.suggested_mechanism, rationale: "Sponsor routed from detail view", status: "routed" } as any);
        if (label === "Follow-up invitation sent") createCommunication({ submission_id: submission.id, body: "Follow-up invitation sent", communication_type: "invitation", status: "sent" } as any);
      }
      setAction(label);
    };
  return (
   <div className="w-full min-w-0 bg-background text-foreground overflow-x-hidden">
      <div className="mx-auto flex w-full max-w-7xl min-w-0 flex-col gap-6 px-4 py-6 sm:px-6 lg:px-8">
          <section className="w-full grid gap-6 lg:grid-cols-2">
      <Card className="border-border shadow-sm">
      <CardHeader>
      <CardTitle>Submission Summary</CardTitle>
      <CardDescription>Review translated capability, confidence weighting, and recommended mechanism.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
      <p><span className="font-medium">Company:</span> {submission.company}</p>
      <p><span className="font-medium">Translated capability:</span> {submission.translated_capability}</p>
      <p><span className="font-medium">Confidence weighting:</span> {submission.confidence_weighting}</p>
      <p><span className="font-medium">Suggested mechanism:</span> {submission.suggested_mechanism}</p>
      <p><span className="font-medium">Weak signal flag:</span> {submission.weak_signal_flag}</p>
      <Badge variant="secondary">Sponsor review in progress</Badge>
      </CardContent>
      </Card>

      <Card className="border-primary/20 shadow-sm">
      <CardHeader>
      <CardTitle>Actions</CardTitle>
      <CardDescription>Complete a sponsor decision to continue routing or pause review.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
      <div className="flex flex-wrap gap-3">
      <Button onClick={() => applyAction("Routed to mechanism")}>Route to Mechanism</Button>
      <Button variant="secondary" onClick={() => applyAction("Follow-up invitation sent")}>Invite Follow-Up</Button>
      <Button variant="outline" onClick={() => applyAction("Placed on hold")}>Place on Hold</Button>
      </div>
      <Separator />
      <p className="text-sm text-muted-foreground">{action || "No action selected yet."}</p>
      </CardContent>
      </Card>
      </section>
      </div>
    </div>
  );
}